import { Suspense, forwardRef } from 'react'

const LazyLoadable = (Component: any) =>
  forwardRef((props: any, ref?: any) => (
    <Suspense>
      <Component {...props} ref={ref} />
    </Suspense>
  ))

export default LazyLoadable
